import React from 'react';
import styles from './JurorVoteCountBanner.module.scss';
import useJuryStore from '../../store/juryStore';
import JuryBadge from '../JuryBadge/JuryBadge';

/**
 * JurorVoteCountBanner - Sticky header component for Jury views
 * Displays remaining points out of the total budget.
 */
const JurorVoteCountBanner = () => {
    const votes = useJuryStore(s => s.votes);
    const voteLimit = useJuryStore(s => s.voteLimit);
    const usedPoints = Object.values(votes).reduce((s, v) => s + v, 0);
    const remainingPoints = voteLimit - usedPoints;

    return (
        <div className={styles.JurorVoteCountBanner}>
            <div className={styles.BannerText}>
                Noch <JuryBadge>{remainingPoints}</JuryBadge> von {voteLimit} Punkten verfügbar
            </div>
        </div>
    );
};

export default JurorVoteCountBanner;
